import React from 'react';
import './Contact.css';

const Contact: React.FC = () => {
  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="page-title">LET'S CONNECT</h1>
            <div className="hero-subtitle">
              <span className="star">✮</span>
              <span>Got a question, want to collaborate, or give us feedback?</span>
              <span className="star">✮</span>
            </div>
            <p className="hero-description">
              We'd love to hear from you.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Methods + Form */}
      <section className="contact-methods">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Info Section */}
            <div className="contact-info-section">
              <div className="methods-grid">
                <div className="method-item">
                  <div className="method-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <polyline points="22,6 12,13 2,6" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h3>Email</h3>
                  <a href="mailto:eco.fashion.living@gmail.com">eco.fashion.living@gmail.com</a>
                </div>
                <div className="method-item">
                  <div className="method-icon">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" stroke="#900e9b" strokeWidth="2"/>
                      <line x1="12" y1="18" x2="12.01" y2="18" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h3>Instagram DMs</h3>
                  <a href="https://instagram.com/eco.fashion.living" target="_blank" rel="noopener noreferrer">@eco.fashion.living</a>
                </div>
              </div>
              
              <div className="contact-note">
                <p>Whether it's about sizing, shipping, custom pieces, styling advice, or just vintage vibes, don't hesitate to reach out. We're always happy to help.</p>
              </div>
            </div>

            {/* Contact Form Section */}
            <div className="form-container">
              <div className="form-header">
                <h2 style={{display: 'flex', alignItems: 'center'}}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '12px'}}>
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="14,2 14,8 20,8" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="16" y1="13" x2="8" y2="13" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <line x1="16" y1="17" x2="8" y2="17" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="10,9 9,9 8,9" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Contact Form
                </h2>
                <p>Send us a message</p>
              </div>
              <form className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input type="text" id="name" name="name" placeholder="Your full name" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input type="email" id="email" name="email" placeholder="your.email@example.com" required />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input type="text" id="subject" name="subject" placeholder="What's this about?" />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea id="message" name="message" rows={4} placeholder="Tell us more..." required></textarea>
                </div>
                <button type="submit" className="submit-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '6px'}}>
                    <line x1="22" y1="2" x2="11" y2="13" stroke="white" strokeWidth="2"/>
                    <polygon points="22,2 15,22 11,13 2,9 22,2" fill="white"/>
                  </svg>
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Info Sections */}
      <section className="contact-page-info">
        <div className="container">
          <div className="info-grid">
            <div className="info-item">
              <h3>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <circle cx="12" cy="12" r="10" stroke="#900e9b" strokeWidth="2"/>
                  <polyline points="12,6 12,12 16,14" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Response Time
              </h3>
              <p>We typically reply within 1–2 business days, but during busy periods or pop-up weekends, it might take just a little longer, thank you for your patience!</p>
            </div>

            <div className="info-item">
              <h3>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 6.13401 6.13401 3 10 3H14C17.866 3 21 6.13401 21 10Z" stroke="#900e9b" strokeWidth="2"/>
                  <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="#900e9b" strokeWidth="2"/>
                </svg>
                Visit Our Studio
              </h3>
              <p>Want to visit the studio in Thessaloniki? You can find everything you need to know <a href="/space">here → Visit Our Space</a></p>
              
            </div>
            
            <div className="info-item">
              <h3>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <path d="M20.84 4.61C20.3292 4.09916 19.7228 3.69312 19.0554 3.41586C18.3879 3.13859 17.6725 2.99548 16.95 3C16.2275 2.99548 15.5121 3.13859 14.8446 3.41586C14.1772 3.69312 13.5708 4.09916 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99548 7.05 3C5.59096 2.99548 4.19169 3.57831 3.16 4.61C2.12831 5.64169 1.54548 7.04097 1.55 8.5C1.54548 9.95903 2.12831 11.3583 3.16 12.39L12 21.23L20.84 12.39C21.8717 11.3583 22.4545 9.95903 22.45 8.5C22.4545 7.04097 21.8717 5.64169 20.84 4.61V4.61Z" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Collaborations
              </h3>
              <p>For collabs, pop-up invites, interviews, or anything fun, please email with the subject line <strong>COLLAB</strong> so we don't miss it!</p>
            </div>

            <div className="info-item">
              <h3>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                  <circle cx="12" cy="12" r="10" stroke="#900e9b" strokeWidth="2"/>
                  <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="12" y1="17" x2="12.01" y2="17" stroke="#900e9b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                FAQs & Policies
              </h3>
              <p>For quick answers about shipping, exchanges, or store policies, check out the <a href="/faqs"><strong>Info & FAQs</strong></a> section.</p>
            </div>
            
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <div className="newsletter-header">
              <h2 style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '12px'}}>
                  <path d="M20.84 4.61C20.3292 4.09916 19.7228 3.69312 19.0554 3.41586C18.3879 3.13859 17.6725 2.99548 16.95 3C16.2275 2.99548 15.5121 3.13859 14.8446 3.41586C14.1772 3.69312 13.5708 4.09916 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99548 7.05 3C5.59096 2.99548 4.19169 3.57831 3.16 4.61C2.12831 5.64169 1.54548 7.04097 1.55 8.5C1.54548 9.95903 2.12831 11.3583 3.16 12.39L12 21.23L20.84 12.39C21.8717 11.3583 22.4545 9.95903 22.45 8.5C22.4545 7.04097 21.8717 5.64169 20.84 4.61V4.61Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                NEWSLETTER
              </h2>
              <p>Get updates on new arrivals, exclusive offers, and styling tips.</p>
            </div>
            
            <div className="newsletter-signup">
              <form className="signup-form">
                <input type="email" placeholder="Enter your email" className="email-input" />
                <button type="submit" className="signup-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '6px'}}>
                    <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <polyline points="22,6 12,13 2,6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;